import styled from "styled-components";

export const Title = styled.h1``;

export const Paragraph = styled.p`
  font-size: 20px;
  padding-right: 20px;
  padding-left: 20px;
  text-align: center;
`;

export const CardList = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;
